<script lang="ts">
	import { InputType } from '..'
	import { _ } from '@repo/i18n'
	import { Action, Image } from '@repo/ui'
	import { Icon } from '@repo/ui'
	import { XMark } from '@steeze-ui/heroicons'

	interface Props {
		type: InputType
		previewData?: string
		previewClass?: string
		deleteLabel?: string
		defaultThumbnail?: string
		onclick?: (event: Event) => void
		children?: import('svelte').Snippet
	}

	let {
		type,
		previewData = $bindable(''),
		previewClass = '',
		deleteLabel = '',
		defaultThumbnail = '',
		onclick,
		children,
	}: Props = $props()
</script>

<div
	class="relative flex h-28 items-center justify-center rounded-md border {previewClass
		? previewClass
		: 'border-gray-200'} px-4 py-7"
>
	{@render children?.()}
	{#if type === InputType.image}
		{#if defaultThumbnail}
			<div class="flex h-[54px] max-w-full items-center justify-center">
				<Image contain path={defaultThumbnail} />
			</div>
		{:else}
			<img class="h-full w-full object-contain" alt="" src={previewData} />
		{/if}
	{:else}
		{previewData}
	{/if}

	<Action
		name="file-preview-delete"
		class="absolute bottom-2 flex items-center space-x-1 text-xs text-red-400"
		{onclick}
	>
		<Icon src={XMark} xSmall />

		<span>
			{$_('button.delete')}
			{deleteLabel}
		</span>
	</Action>
</div>
